// Increase the version number to force clearing persisted redux state for all users
// This is useful when we have a breaking change in the redux state or have a new feature that requires a fresh redux state structure
export const REDUX_PERSIST_KEY_PREFIX: string = 'CHARGER_v5_'
